module.exports = __webpack_public_path__ + "img/Oxidation Marks.f49b23d0.png";